import React, { useState, useEffect } from "react";
import { TextField, Button, Box, Grid, FormControl, InputLabel, Select, MenuItem, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { styled } from "@mui/material/styles";
import API from "../../../../api/index";
import { startToast, updateToastSuccess, updateToastError } from '../../../../utils/notification-loading';

const StyledText = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 12,
    backgroundColor: "#1e1e1e",
    color: "#fff",
    '& fieldset': {
      borderColor: "#3f3f3f",
    },
    '&:hover fieldset': {
      borderColor: "#52a0a6",
    },
    '&.Mui-focused fieldset': {
      borderColor: "#52a0a6",
    },
  },
  '& .MuiInputLabel-root': {
    color: "#aaa",
    '&.Mui-focused': {
      color: "#52a0a6",
    },
  },
}));

const AddLecsReseller = ({setOpen}) => {
  const [auth, setAuth] = useState("");
  const [serialnumber, setSerialNumber] = useState("");
  const [name, setName] = useState("");
  const [activationCode, setActivationCode] = useState("");
  const [location, setLocation] = useState("");
  const [localAdmins, setLocalAdmins] = useState([]);
  const [selectedLocalAdmin, setSelectedLocalAdmin] = useState([]);
  const [action, setAction] = useState("new");
  const [licenseList, setLicenseList] = useState([]);

  useEffect(() => {
    API.getResType().then((res) => {
      const role = res.data.auth;
      setAuth(role);
      

      if (role === "super-admin") {
        API.getLocalAdmins().then((res) => {
          const formatted = res.data.map((admin) => ({
            code: admin.code,
            email: admin.email,
            label: `${admin.nome} ${admin.cognome}`,
          }));
          setLocalAdmins(formatted);
        });
      } 
    });

    API.getLicensesReseller().then((res) => {
      const filtered = res.data.filter((doc) => doc.device_limit > doc.deviceCount)
      setLicenseList(filtered);
    })
  }, []);

  const handleActivationCodeChange = (event) => {
    let value = event.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    value = value.slice(0, 25);
    value = value.replace(/(.{4})/g, '$1-');
    value = value.slice(0, 24);
    setActivationCode(value);
  };

  const handleSubmit = (event) => {
    startToast();
    event.preventDefault();
    let payload = {
      matricola: serialnumber,
      name: name,
      activation_code: activationCode,
      location: location,
      action: action
    }
    if (selectedLocalAdmin.length > 0) {
      payload["adminCode"] = selectedLocalAdmin;
    }

    API.addLecsReseller(payload)
      .then((result) => {
        updateToastSuccess("LECS device has been activated correctly");
        setOpen(false);
      })
      .catch((error) => {
        updateToastError("Error on device activation");
        console.error('[handleSubmit] Error on device activation:', error);
      });
  };

  const handleChangeMatric = (e) => {
    let value = e.target.value.toUpperCase();
    value = value.replace(/[^A-Z0-9-]/g, '');
    value = value.replace(/-+/g, '-');
    if (value.length > 2 && value.charAt(2) !== '-') value = value.slice(0, 2) + '-' + value.slice(2);
    if (value.length > 7) value = value.slice(0, 7);
    setSerialNumber(value);
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", px: 2 }}>
      <Box component="form" noValidate autoComplete="off" sx={{ mt: 3 }} onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <RadioGroup value={action} onChange={(e) => { setActivationCode(""); setAction(e.target.value)}}>
              <FormControlLabel label={"Activate a new License"} control={<Radio value={"new"}/>}/>
              <FormControlLabel label={"Select an existing License"} control={<Radio value={"add"}/>}/>
            </RadioGroup>
          </Grid>
          <Grid xs={12} size={6}>
            <StyledText
              label="Insert your serial number"
              fullWidth
              value={serialnumber}
              onChange={(e) => handleChangeMatric(e)}
              required
            />
          </Grid>
          <Grid xs={12} size={6}>
            <StyledText
              label="Choose a name for this Lecs"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </Grid>
          <Grid size={12}>
            {action === "new" ? (
              <StyledText
                label="Insert your license"
                fullWidth
                value={activationCode}
                onChange={handleActivationCodeChange}
                required
                slotProps={{
                  htmlInput: {
                    onInput: (e) => {
                      let cleaned = e.target.value.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
                      if (cleaned.length > 20) cleaned = cleaned.slice(0, 20);
                      const formatted = cleaned.match(/.{1,4}/g)?.join("-") || "";
                      e.target.value = formatted;
                    }
                  }
                }}
              />
            ):(
              <StyledText
                label="Choose your license"
                value={activationCode}
                onChange={(e) => setActivationCode(e.target.value)}
                fullWidth 
                select 
                required
                slotProps={{
                  select: {
                    MenuProps: {
                      PaperProps: {
                        sx: {
                          maxHeight: 150,
                        },
                      },
                    },
                  },
                }}
              >
                {licenseList.map((license) => (
                  <MenuItem value={license.codiceAttivazione}>{license.codiceAttivazione}</MenuItem>
                ))}
              </StyledText>
            )}
            
          </Grid>
          <Grid size={12}>
            <StyledText
              label="Enter the location"
              fullWidth
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              required
            />
          </Grid>

          {auth === "super-admin" && (
            <Grid xs={12} size={6}>
              <FormControl fullWidth size="small">
                <InputLabel id="admin-select-label" sx={{ color: "#aaa" }}>
                  Local Admin
                </InputLabel>
                <Select
                  labelId="admin-select-label"
                  id="admin-select"
                  multiple
                  value={selectedLocalAdmin}
                  label="Local Admin"
                  onChange={(e) => setSelectedLocalAdmin(e.target.value)}
                  renderValue={(selected) =>
                    selected
                      .map((code) => localAdmins.find((a) => a.code === code)?.label || code)
                      .join(", ")
                  }
                  sx={{
                    color: "#fff",
                    borderRadius: 2,
                    backgroundColor: "#1e1e1e",
                    '.MuiOutlinedInput-notchedOutline': {
                      borderColor: "rgba(255,255,255,0.2)",
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: "#52a0a6",
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: "#888",
                    },
                    '.MuiSvgIcon-root': {
                      color: "#ccc",
                    },
                  }}
                >
                  {localAdmins.map((admin, i) => (
                    <MenuItem key={i} value={admin.code}>
                      {admin.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
        </Grid>

        <Button
          type="submit"
          variant="contained"
          fullWidth
          sx={{
            mt: 4,
            py: 1.5,
            fontWeight: 600,
            background: "#52a0a6",
            color: "#fff",
            borderRadius: 10,
            textTransform: "none",
            fontSize: "1rem",
            transition: "all 0.3s ease",
            '&:hover': {
              backgroundColor: "#6dd5d8",
              color: "#000",
              boxShadow: "0px 4px 20px rgba(82, 160, 166, 0.3)",
            },
          }}
        >
          Register
        </Button>
      </Box>
    </Box>
  );
};

export default AddLecsReseller;
